import $ from 'jquery';
import Sloth from '../../components/Sloth';
import './index.scss';

@Sloth.component({})
export default class HomeChart {
    onInit() {
        const dom = this.dom;

        $('.Block-more', dom).on('click', () => {
            $('.Block-content', dom).toggle();
        });
    }
}

@Sloth.component({})
export class HomeLinks {
    onInit() {
        const self = this;
        const dom = this.dom;

        $('.Home-links-more', dom).on('click', function (evt) {
            evt.preventDefault();

            const title = $(this).parents('.Home-links-block').find('.Home-links-title').text();
            const body = $(this).parent().find('.Home-links-list').clone().addClass('Home-links-listAll');
            self.Modal.show({ title, body });
        });
    }

    get Modal() {
        return $('.Home-links-modal').get(0).component;
    }
}




/** WEBPACK FOOTER **
 ** ./src/Home/index.js
 **/